<template>
  <v-list-item style="border-bottom: 1px solid rgb(228, 228, 228); background-color: white;" @click="$emit('click')">
    <v-list-item-icon class="my-auto mr-3">
      <v-icon :color="color" size="22">
        {{ event.IsAbsence ? 'mdi-beach' : statusicon(event.JobStatus.Id) }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-content class="py-0 mr-3" style="max-width: 100px;">
      <v-list-item-title :style="'color:' + color + ';'">
        {{ event.IsAbsence ? $t('servicesystem.common_objects.appointment.types.absence') : event.JobStatus.Name }}
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ title }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ subtitle }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-content class="py-0" style="max-width: 250px;">
      <v-list-item-title>
        {{ i18nFormatTime(event.StartTime) }} - {{ i18nFormatTime(event.EndTime) }}
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action class="my-auto ml-4">
      <v-btn v-if="!event.IsAbsence" icon :to="{ name: 'ViewJob', params: { filter: 'my', jobId: event.JobId } }">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>


<script>
export default {
  name: "EventListItem",
  props: {
    event: Object,
  },
  components: {},

  data() {
    return {
    };
  },

  mounted() {

  },

  methods: { },

  computed: {
    title() {
      return this.event.Subject;
    },
    subtitle() {
      if (this.event.IsAbsence) {
        return this.event.Subject;
      }
      else {
        var names = this.event.Participants.map(resource => resource.User.Name);
        return names.join(', ');
      }
    },
    color() {
      if (this.event.IsAbsence) {
        return 'black'
      }
      else {
        return this.statuscolor(this.event.JobStatus.Id); 
      }
    },
  },

  watch: {},

  /*
  var title = StringHelper.encodeHtml(eventRecord.name);
  var subtitle = "";
  //participants single element   StringHelper.encodeHtml(eventRecord.resources.map(resource => resource.name)),
  //participants multi element  eventRecord.resources.map(resource => ({ html: resource.name, })),
  if (eventRecord.loading) {
    renderData.cls += 'eventloading';
  }
  if (eventRecord.jobId) {
    renderData.eventColor = this.colorFunc(eventRecord.jobStatusId);
    subtitle = StringHelper.encodeHtml(this.addressDtoToString(eventRecord.address));
  }
  else { //diff style for abscence
    renderData.eventStyle = 'colored';
    renderData.eventColor = 'black';

    let Difference_In_Time = eventRecord.endDate.getTime() - eventRecord.startDate.getTime();
    let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    var format = Difference_In_Days ? "ddd D. MMM" : "hh:mm"; //show time if duration less than a day, else show the dates
    subtitle = `${DateHelper.format(eventRecord.startDate, format)} - ${DateHelper.format(eventRecord.endDate, format)}`;
  }
  return {
    className: 'assigned',
    children: [
      { style: 'font-size: 12px', html: title },
      { style: 'font-size: 11px', html: subtitle },
    ]
  };
  */
};
</script>

<style lang="scss" scoped></style>